import React from 'react'
import { DefaultDataTable } from '../../../components/dataTable/DefaultDataTable'

export const LocalizacaoList = (props) => <DefaultDataTable data={props} />
